// constants.ts
import * as yup from 'yup';

export const SCOPE_OPTIONS = [
    {
        id: "event_management",
        name: "Gestion des Eevents",
        description: "Création, visualisation et modification d'un eevent.",
    },
    {
        id: "dashboard_freemium_statistics",
        name: "Statistiques Dashboard Freemium",
        description: "Statistiques globales par localisation et par catégories.",
    },
    {
        id: "event_freemium_statistics",
        name: "Statistiques par Eevent (Freemium)",
        description: "Statistiques des interactions d'un événement et comparaison avec le marché (Vues, Likes, Share, Billetterie).",
    },
    {
        id: "dashboard_premium_statistics",
        name: "Statistiques Dashboard Premium",
        description: "Statistiques d'interactions par sous-catégories et localisation, total des interactions par événements.",
    },
    {
        id: "event_premium_statistics",
        name: "Statistiques par Eevent (Premium)",
        description: "Analyse avancée : événements similaires, organisateurs similaires, audience potentielle, tendances horaires et heatmap des événements similaires.",
    }
];


export const abonnementSchema = yup.object().shape({
    name: yup.string().required("Le nom est requis."),
    stripe_plan_id: yup.string().required("L'ID Stripe est requis."),
});